module.exports = __webpack_public_path__ + "static/wing-chun-kosova-eb2497a3f85819a51d3a8a4a325c6717.jpg";